module.exports = __webpack_public_path__ + "img/player-control-bg.547b8ded.jpg";